module.exports = __webpack_public_path__ + "static/media/GRT.0ad3ee87.svg";